<template>
  <div id="search-page" class="page">
    <template>
      <section id="content_section" class="container bg-white">
        <div class="main-search-container" :class="(!selected && !params.q)? 'd-block': ''">
          <SearchBox />
        </div>
        <b-tabs v-if="selected !== null" v-model="selected" content-class="mt-4">
          <b-tab v-for="(type, i) in types" :key="type.key" :title="type.title">
            <div v-if="selected === i" class="px-lg-3">
              <div v-if="loading" class="loader my-5" />
              <template v-else>
                <template v-if="items && items.length > 0">
                  <h5
                    class="font-weight-bold"
                  >{{ $tc('search.count_results', items.length, { count: total } ) }}</h5>
                  <div class="search-result-list my-3">
                    <b-card
                      v-for="(item, j) in items"
                      :id="`${type.key}_item_${j}`"
                      :key="`${type.key}_item_${j}`"
                      class="search-result"
                    >
                      <CustomLink :url="getItemUrl(item)" target="_blank">
                        <h6 class="font-weight-bold text-osc">
                          <text-highlight
                            :queries="[keyword]"
                          >{{ getDataValue('headline', item) || getDataValue('name', item) }}</text-highlight>
                        </h6>
                        <p class="html-body">
                          <text-highlight
                            :queries="[keyword]"
                          >{{ getPlainText(getDataValue('body', item)) }}</text-highlight>
                        </p>
                      </CustomLink>
                      <div v-if="item.published_at" class="date">
                        <CustomLink
                          :url="getItemUrl(item)"
                          target="_blank"
                        >{{ formatDate(item.published_at) }}</CustomLink>
                      </div>
                    </b-card>

                    <div v-if="total_page > 1" class="pagination-container">
                      <nav>
                        <ul class="pagination justify-content-center list-unstyled m-0">
                          <template v-if="total_page > 4 && params.page_num > 1 + 2">
                            <li key="page_item_first" class="page-item">
                              <!-- <b-link class="page-link" v-on:click="goToPage(1)">«</b-link> -->
                              <b-link class="page-link" @click="goToPage(1)">1</b-link>
                            </li>
                            <li class="page-item">
                              <span>…</span>
                            </li>
                          </template>
                          <template v-for="page of total_page">
                            <template
                              v-if="(page + 2 >= params.page_num && page - 2 <= params.page_num) || ((params.page_num === 1 || params.page_num === total_page ) && page + 3 >= params.page_num && page - 3 <= params.page_num)"
                            >
                              <li
                                :key="`page_item${page}`"
                                class="page-item"
                                :class="{active: params.page_num === page}"
                              >
                                <b-link class="page-link" @click="goToPage(page)">{{ page }}</b-link>
                              </li>
                            </template>
                          </template>
                          <template v-if="total_page > 4 && params.page_num < total_page - 2">
                            <li class="page-item">
                              <span>…</span>
                            </li>
                            <li key="page_item_last" class="page-item">
                              <!-- <b-link class="page-link" v-on:click="goToPage(total_page)">»</b-link> -->
                              <b-link
                                class="page-link"
                                @click="goToPage(total_page)"
                              >{{ total_page }}</b-link>
                            </li>
                          </template>
                        </ul>
                      </nav>
                    </div>
                  </div>
                </template>
                <div v-else>
                  <p>{{ $t('search.hint_no_results', { type: type.title } ) }}:</p>
                  <h3>"{{ params.q }}"</h3>
                </div>
              </template>
            </div>
          </b-tab>
        </b-tabs>
      </section>
    </template>
  </div>
</template>

<script>
import CustomLink from "@/components/CustomLink";
import moment from "moment";
import _ from "lodash";
import TextHighlight from "vue-text-highlight";
import SearchBox from "@/components/SearchBox";

export default {
  name: "Search",
  components: {
    CustomLink,
    TextHighlight,
    SearchBox
  },
  data() {
    return {
      selected: null,
      types: [],
      params: [],
      keyword: null, // returned from api
      loading: false,
      items: [],
      total: 0,
      total_page: 0
    };
  },
  watch: {
    $route(to, from) {
      var newParams = to.query;
      var oldParams = from.query;
      if (
        newParams.q !== oldParams.q ||
        newParams.page_num !== oldParams.page_num
      ) {
        this.init();
      }
    },
    selected(val) {
      var to = this.$router.history.current;
      let type = this.types[val].key;
      if (to.params.type !== type) {
        this.params["page_num"] = 1;
        this.$router.push({
          path: "/search/" + type,
          query: this.params
        });
      }
      // this.init();
    }
  },
  mounted() {
    let __this = this;
    __this.$http
      .get("cipher")
      .then(response => {
        if (response.data.success) {
          let keys = _.map(response.data.data, "table_key");
          var types = [];
          for (let key of keys) {
            types.push({
              key: key,
              title: this.$t("page." + key)
            });
          }
          __this.types = types;
          __this.init();
        } else throw { response: response };
      })
      .catch(error => {
        console.log(error);
      });
  },
  methods: {
    goToPage(pageNum) {
      let params = this.$route.params;
      let path = "/search/" + params.type;
      this.$router.push({
        path: path,
        query: {
          ...this.$route.query,
          page_num: pageNum
        }
      });
    },
    getPlainText(html) {
      var temp = document.createElement("div");
      temp.innerHTML = html;
      return temp.textContent || temp.innerText || "";
    },
    getParams(to) {
      let type = to.params.type;
      for (var i = 0; i < this.types.length; i++) {
        if (this.types[i].key === type) {
          this.selected = i;
          break;
        }
      }
      return {
        q: this.$route.query.q,
        page_num: this.$route.query.page_num || 1
      };
    },
    init() {
      var to = this.$router.history.current;
      this.params = this.getParams(to);
      if (this.selected === null) {
        this.$router.replace("/search");
      } else {
        this.search();
      }
    },
    search() {
      if (this.selected === null) return;
      this.items = [];
      this.total = this.total_page = 0;
      let __this = this;
      __this.loading = true;

      let type = this.types[this.selected].key;
      this.$http
        .get("search", {
          params: {
            table: type,
            ...__this.params
          }
        })
        .then(response => {
          __this.loading = false;
          if (response.data.success) {
            let data = response.data.data;
            __this.items = data.items;
            __this.total = data.total;
            __this.total_page = data.total_page;
            __this.keyword = data.keywords;
          } else
            throw {
              response: response
            };
        })
        .catch(error => {
          console.log(error);
          __this.loading = false;
          __this.items = [];
          __this.total = __this.total_page = 0;
        });
    },
    formatDate(date) {
      var val = moment(date);
      let format = "";
      if (this.$i18n.locale === "en") {
        format = "D MMM";
        if (val.isBefore(this.year)) {
          format += ", YYYY";
        }
      } else {
        format = "MM-DD";
        if (val.isBefore(this.year)) {
          format = "YYYY-" + format;
        }
      }
      return val.format(format);
    },
    getItemUrl(item) {
      let url = null;
      let type = this.types[this.selected].key;
      switch (type) {
        case "achievements":
          url = `/article/achievement/${item.article_id}`;
          break;
        case "events":
          url = item.url ? `/event/${item.url}` : `/events/${item.type}`;
          break;
        case "news":
          url = item.ref_url;
          break;
        case "beneficiaries":
          url = "/beneficiaries/" + item.category;
          break;
        default:
          url = item.url;
          break;
      }
      return url;
    }
  }
};
</script>
<style lang="scss" src="../assets/scss/search.scss"></style>
